import api from 'api'
import { ACCEPT_LEAD } from '../constants/endpointKeys'
import { type IAcceptLeadPayload, type IAcceptLeadResponse } from './types'

export async function acceptLead(payload: IAcceptLeadPayload) {
  return await api.post<IAcceptLeadResponse>(ACCEPT_LEAD, payload)
}
